import request from '@/utils/request'

/**
 *获取配置
 * @param {*} data 
 */
export function 	getPrice(data){
    return request({
        url: '/common/systemPrice',
        method: 'post',
        data
    })
}
/**
 *八、修改价格系数
 * @param {*} data 
 */
export function 	updatePrice(data){
    return request({
        url: '/common/updatePrice',
        method: 'post',
        data
    })
}
/**
 *获取快递
 * @param {*} data 
 */
export function 	expressList(data){
    return request({
        url: '/common/expressList',
        method: 'get',
        data
    })
}


// WEBPACK FOOTER //
// ./src/api/confirm.js